"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShatterAbilityHandler = exports.ShatterActorAbilityFactory = exports.ShatterAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Registries_1 = require("../../core/state/Registries");
class ShatterAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Shatter;
        this.__typeName = "Shatter";
    }
}
exports.ShatterAbilityArgs = ShatterAbilityArgs;
let ShatterActorAbilityFactory = class ShatterActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Shatter", "OneEnemies", 1);
    }
};
ShatterActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Shatter")
], ShatterActorAbilityFactory);
exports.ShatterActorAbilityFactory = ShatterActorAbilityFactory;
let ShatterAbilityHandler = class ShatterAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 55)
            ],
            onHit(sequence) {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(selectedEnemy, "feet"), "BeamFromTheHeavens"));
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new Vulnerability_1.VulnerabilityEffectArgs(2),
                    duration: Duration_1.Duration.Turns(4),
                    sequence
                });
            }
        });
    }
};
ShatterAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Shatter)
], ShatterAbilityHandler);
exports.ShatterAbilityHandler = ShatterAbilityHandler;
